// Compact address editor used by the Customer 360 address book.
import { useState } from "react";
import { Check, Loader2, X } from "lucide-react";
import { pickFields } from "../../lib/addressBook";

const input = "w-full px-2 py-1.5 rounded bg-slate-900/60 border border-white/10 text-slate-100 text-[12px] font-mono focus:outline-none focus:ring-1 focus:ring-orange-500/60 placeholder:text-slate-600";

export default function AddressForm({ initial, kind, onSave, onCancel, testid }) {
  const [f, setF] = useState({ ...pickFields(initial), label: initial?.label || "", is_default: !!initial?.is_default });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const submit = async () => {
    setBusy(true);
    try { await onSave(f); } finally { setBusy(false); }
  };
  const field = (k, ph, cls = "") => (
    <input value={f[k]} onChange={set(k)} placeholder={ph} className={`${input} ${cls}`} data-testid={`${testid}-${k}`} />
  );
  return (
    <div className="space-y-2 rounded-md border border-orange-500/25 bg-orange-500/[0.03] p-2.5" data-testid={testid}>
      <div className="grid grid-cols-2 gap-2">
        {field("label", kind === "billing" ? "Label (e.g. Accounts dept)" : "Label (e.g. Bermondsey site)", "col-span-2")}
        {field("name", "Contact name")}
        {field("company", "Company")}
        {field("line1", "Address line 1", "col-span-2")}
        {field("line2", "Address line 2", "col-span-2")}
        {field("city", "Town / city")}
        {field("county", "County")}
        {field("postcode", "Postcode")}
        {field("country", "Country")}
        {field("phone", "Phone", "col-span-2")}
      </div>
      <div className="flex items-center justify-between gap-2">
        <label className="inline-flex items-center gap-1.5 text-[11px] text-slate-300 cursor-pointer">
          <input type="checkbox" checked={f.is_default} onChange={(e) => setF((x) => ({ ...x, is_default: e.target.checked }))} data-testid={`${testid}-default`} />
          Make default {kind === "billing" ? "billing" : "delivery"} address
        </label>
        <div className="flex items-center gap-1">
          <button type="button" onClick={onCancel} disabled={busy} className="p-1 rounded text-slate-400 hover:text-white hover:bg-white/5" data-testid={`${testid}-cancel`}><X className="w-3.5 h-3.5" /></button>
          <button type="button" onClick={submit} disabled={busy || !(f.line1 || f.postcode)} data-testid={`${testid}-save`}
            className="text-[11px] text-emerald-300 hover:text-emerald-200 font-mono px-2 py-1 rounded bg-emerald-500/10 border border-emerald-500/30 inline-flex items-center gap-1 disabled:opacity-40">
            {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Check className="w-3 h-3" />} Save
          </button>
        </div>
      </div>
    </div>
  );
}
